export default "__VITE_ASSET__C0T56GEv__"